'use client';
import React from 'react';
import { DataGrid } from '@mui/x-data-grid/DataGrid';

const DataGridNode = (props: any) => {
  return <DataGrid autoHeight={true} {...props} />;
};

export default DataGridNode;
